import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Safe20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.25 7.35352V5H10.75V7.35352C12.3902 7.81742 13.2152 9.73296 12.457 11.2366L14.916 12.876L14.084 14.1241L11.4258 12.352C10.5597 12.8782 9.44036 12.8782 8.57417 12.352L5.91603 14.1241L5.08398 12.876L7.54305 11.2366C6.78478 9.73297 7.60982 7.81742 9.25 7.35352ZM8.75 10C8.75 9.30964 9.30964 8.75 10 8.75C10.6904 8.75 11.25 9.30964 11.25 10C11.25 10.6904 10.6904 11.25 10 11.25C9.30964 11.25 8.75 10.6904 8.75 10Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.25 2.57143C1.25 1.84162 1.84162 1.25 2.57143 1.25H17.4286C18.1584 1.25 18.75 1.84162 18.75 2.57143V17.4286C18.75 18.1584 18.1584 18.75 17.4286 18.75H2.57143C1.84162 18.75 1.25 18.1584 1.25 17.4286V2.57143ZM2.75 2.75V17.25H17.25V2.75H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Safe20.displayName = 'Safe20';
export default Safe20;
